import React, { useState, useCallback, useEffect } from 'react';
import { Typography, Box, useMediaQuery, useTheme, Grid, FormControl, CircularProgress } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { SelectField } from '../../../../../Components/Field';
import { TypedFormFieldValue } from '../../../../../Components/Form/Form.types';
import { useStyles } from '../../../../../Components/Field/Field.styles';
import { SelectOption } from '../../../../../Components/Form/Form.types';
import { StepButtonBar } from '../OtherRequirementWizard/StepButtonBar';
import { StepProps } from './types';
import { useAptorApi } from '../../../../../Api';
import UpdateConnectionInfo from './UpdateConnectionInfo';

interface Step4LawNewCompanyUnitManagersProps extends StepProps {
  selectedManagers?: SelectOption[];
  onManagersSelect: (managers: SelectOption[]) => Promise<void>;
  isLoading?: boolean;
  currentStepName: string;
  updateConnectionInfo: any;
  setUpdateConnectionInfo: (info: any) => void;
}

const Step4LawNewCompanyUnitManagers = ({
  onNext,
  onBack,
  onCancel,
  isFirstStep,
  selectedManagers = [],
  onManagersSelect,
  isLoading = false,
  currentStepName,
    updateConnectionInfo,
  setUpdateConnectionInfo,
}: Step4LawNewCompanyUnitManagersProps) => {
  const [localSelected, setLocalSelected] = useState<SelectOption[]>(selectedManagers);
  const [complianceUserOptions, setComplianceUserOptions] = useState<SelectOption[]>([]);
  const [isLoadingOptions, setIsLoadingOptions] = useState(false);
  const { formatMessage } = useIntl();
  const { api, abortController } = useAptorApi();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const paperPadding = isMobile ? theme.spacing(3) : theme.spacing(8);
  const classes = useStyles();

  useEffect(() => {
    setIsLoadingOptions(true);
    api
      .getCustomerUsers()
      .then((result: any) => {
        if (!abortController.current.signal.aborted) {
          const users = result?.items || [];
          const options = (Array.isArray(users) ? users : []).map((u: any) => ({ label: u.name, value: u.id }));
          setComplianceUserOptions(options);
          setIsLoadingOptions(false);
        }
      })
      .catch((error) => {
        if (!abortController.current.signal.aborted) {
          console.error('Failed to load compliance users:', error);
          setIsLoadingOptions(false);
        }
      });
  }, []);

  const handleChange = useCallback((val: TypedFormFieldValue<number> | TypedFormFieldValue<number>[] | undefined) => {
    if (Array.isArray(val)) {
      setLocalSelected(val as SelectOption[]);
    } else if (val && !Array.isArray(val)) {
      setLocalSelected([val as SelectOption]);
    } else {
      setLocalSelected([]);
    }
  }, []);

  const handleSave = async () => {
    await onManagersSelect(localSelected);
  };

  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          display: 'flex',
          width: '100%',
          gap: '10px',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'stretch',
        }}
      >
        <div
          style={{
            width: isMobile ? '100%' : 'calc(50% - 5px)',
            flexShrink: 0,
            padding: paperPadding,
            backgroundColor: '#f7f0f1',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '350px',
          }}
        >
          {isLoadingOptions ? (
            <CircularProgress />
          ) : (
            <Box style={{ maxWidth: '320px', width: '100%' }}>
              {/* <Typography variant="body2" style={{ marginBottom: theme.spacing(2) }}>
                {formatMessage({ id: 'law-portal.manage.edit-law.complianceUsers' })}
              </Typography> */}
              <Grid container spacing={3} justifyContent="flex-start">
                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                  <Box style={{ maxWidth: '100%', width: '100%', minWidth: '320px' }}>
                    <FormControl className={classes.formControl} style={{ width: '100%' }}>
                      <SelectField
                        name="complianceUsers"
                        placeholder={formatMessage({ id: 'law-portal.manage.edit-law.complianceUsers' })}
                        options={complianceUserOptions}
                        isMulti={true}
                        errorTexts={[]}
                        initialState={localSelected}
                        onChange={handleChange}
                      />
                    </FormControl>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          )}
        </div>
        <UpdateConnectionInfo
        updateConnectionInfo={updateConnectionInfo}
        currentStepName={currentStepName}
        onUpdate={setUpdateConnectionInfo}
      />
      </div>

      <Box>
        <StepButtonBar
          onCancel={onCancel}
          onBack={onBack}
          onNext={handleSave}
          nextLabel="form.save"
          nextDisabled={isLoading}
          isLoading={isLoading}
          formatMessage={formatMessage}
          showBack={!isFirstStep}
          isDeleteStep={true}
        />
      </Box>
    </div>
  );
};

export default Step4LawNewCompanyUnitManagers;
